const AutomationRunStatusEnum = Object.freeze({
  0: 'Automations_Field_StatusRunning',
  1: 'Automations_Field_StatusStopped'
})

const AutomationRunStatusLabelsEnum = Object.freeze({
  RUNNING: 0,
  STOPPED: 1
})

export { AutomationRunStatusEnum, AutomationRunStatusLabelsEnum }



// WEBPACK FOOTER //
// ./src/modules/automations/enum/AutomationRunStatusEnum.js